export default __webpack_public_path__ + "static/media/Android3.ff295e76.jpg";